import React, { Component } from 'react';
import {createBrowserHistory} from 'history';
import {BrowserRouter as Router, Route} from 'react-router-dom';
import { Link } from 'react-router-dom';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Layout
import { Footer } from './components/layout/Footer';
// pages
import Home from './components/Home';
import Home2 from './components/Home2';
import Home3 from './components/Home3';
import Home2_Header2 from './components/Header_style_02';
import Home3_Header3 from './components/Header_style_03';
import Aboutus_01 from './components/pages/Aboutus_01';
import Services_01 from './components/pages/Services_01';
import Our_team from './components/pages/Our_team';
import Team_detail from './components/pages/Team_detail';
import Faq from './components/pages/Faq';
import Contact_01 from './components/pages/Contact_01';
import Error from './components/pages/Error';
import content_engineering from './components/services/content_engineering';
import experience_design from './components/services/experience_design';
import Project_style1 from './components/project/Project_style1';
import Project_style2 from './components/project/Project_style2';
import project_details from './components/project/project_details';
import Blog from './components/blog/Blog';
import Single_blog from './components/blog/Single_blog';
import Shop from './components/shop/Shop';
import Product_details from './components/shop/Product_details';
import ScrollToTop from './components/layout/Gotop';

const appHistory = {
  basename: process.env.PUBLIC_URL
};
const history = createBrowserHistory(appHistory);
function App() {
 
  return (
    <div className="page">
      <Router basename={process.env.PUBLIC_URL} history={history}>  
        <div id="preloader">
          <div id="status">&nbsp;</div>
        </div>   
        <ScrollToTop />
            <Route exact path='/' component={ Home } /> 
            <Route path='/home2' component={ Home2 } /> 
            <Route path='/home3' component={ Home3 } />
            <Route path='/header_style_02' component={ Home2_Header2 } />
            <Route path='/header_style_03' component={ Home3_Header3 } />
            <Route path="/aboutus_01" component={Aboutus_01} />
            <Route path="/services_01" component={Services_01} />
            <Route path="/Our_team" component={Our_team} />
            <Route path="/team_detail" component={Team_detail} />
            <Route path="/faq" component={Faq} />
            <Route path="/contact_01" component={Contact_01} />
            <Route path="/error" component={Error} />
            <Route path="/content_engineering" component={content_engineering} />
            <Route path="/experience_design" component={experience_design} />
            <Route path="/project_style1" component={Project_style1} />
            <Route path="/project_style2" component={Project_style2} />
            <Route path="/project_details" component={project_details} />
            <Route path="/blog" component={Blog} />
            <Route path="/single_blog" component={Single_blog} />
            <Route path="/shop" component={Shop} />
            <Route path="/product_details" component={Product_details} />
        <Footer />
    </Router>  
    </div> 
  );
 }

export default App;
